var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Injectable } from '@angular/core';
var SVGService = /** @class */ (function () {
    function SVGService() {
    }
    SVGService.prototype.getSVGSVGElement = function (width, height) {
        var svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
        svg.setAttribute('width', width);
        svg.setAttribute('height', height);
        return svg;
    };
    SVGService.prototype.getSVGGElement = function (stroke, strokeWidth, fill) {
        var g = document.createElementNS('http://www.w3.org/2000/svg', 'g');
        g.setAttributeNS(null, 'stroke', stroke);
        g.setAttributeNS(null, 'stroke-width', strokeWidth);
        g.setAttributeNS(null, 'fill', fill);
        return g;
    };
    SVGService.prototype.getSVGLineElement = function (x1, y1, x2, y2, stroke, strokeWidth) {
        var line = document.createElementNS('http://www.w3.org/2000/svg', 'line');
        line.setAttributeNS(null, 'x1', x1);
        line.setAttributeNS(null, 'y1', y1);
        line.setAttributeNS(null, 'x2', x2);
        line.setAttributeNS(null, 'y2', y2);
        line.setAttributeNS(null, 'stroke', stroke);
        line.setAttributeNS(null, 'stroke-width', strokeWidth);
        return line;
    };
    SVGService.prototype.getSVGPathElement = function (d) {
        var path = document.createElementNS('http://www.w3.org/2000/svg', 'path');
        path.setAttributeNS(null, 'd', d);
        return path;
    };
    SVGService.prototype.getSVGMarkerElement = function (id, markerWidth, markerHeight, refX, refY) {
        var marker = document.createElementNS('http://www.w3.org/2000/svg', 'marker');
        marker.setAttributeNS(null, 'id', id);
        marker.setAttributeNS(null, 'markerWidth', markerWidth);
        marker.setAttributeNS(null, 'markerHeight', markerHeight);
        marker.setAttributeNS(null, 'refX', refX);
        marker.setAttributeNS(null, 'refY', refY);
        return marker;
    };
    SVGService = __decorate([
        Injectable()
    ], SVGService);
    return SVGService;
}());
export { SVGService };
